import React from "react";
import styled from "styled-components";
import { Flex, Box } from "rebass";
import { Icon, Heading, Subheading, TextStyle } from "@shopify/polaris";

export const CarouselWrapper = styled.div`
  margin-top: 2rem;
  margin-bottom: 2rem;

  .rec-dot {
    background-color: rgba(103, 58, 183, 0.5);
  }

  .rec-dot_active {
    box-shadow: 0 0 1px 3px rgba(103, 58, 183, 1);
  }

  .rec-item-wrapper {
    width: inherit !important;
  }

  .rec-arrow {
  }

  .rec-carousel-item:focus {
    outline: none;
    box-shadow: rgba(80, 184, 60, 0.72);
  }

  .rec.rec-arrow:disabled {
    visibility: hidden;
  }
`;

export const RecentOrder = styled.div`
  :focus {
    outline: none;
  }
  max-width: 400px;
  min-height: 150px;
  border: ${(props) =>
    props.selected ? "1px solid #50B83C" : "1px solid #C4CDD5"};
  border-radius: 0.5em;
  -webkit-box-shadow: 5px 7px 7px -2px ${(props) => (props.selected ? "rgba(80, 184, 60, 0.72)" : "rgba(0,0,0,0.72)")};
  box-shadow: 5px 7px 7px -2px ${(props) => (props.selected ? "rgba(80, 184, 60, 0.72)" : "rgba(0,0,0,0.72)")};
  padding-left: 2rem;
  padding-right: 2rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .card-header {
    display: flex;
    align-items: flex-end;
  }

  .Polaris-Icon {
    margin: inherit;
    margin-left: 0.5em;
    margin-right: 0.5em;
    width: 1rem;
    height: 1rem;
  }
`;

export const Wrapper = styled.div`
  h2 {
    text-align: center;
    text-transform: uppercase;
    font-weight: 400;
    letter-spacing: 1.1px;
  }
  * {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }
  :focus {
    outline: none;
  }
  width: 50%;
  min-height: 150px;
  border: ${(props) =>
    props.selected ? "5px solid #50B83C" : "5px solid #CECECE"};
  border-radius: 0.5em;
  padding-left: 2rem;
  padding-right: 2rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: space-around;

  svg {
    width: 14em;
    height: 50px;
    display: block;
  }
`;

export const IconsSection = styled(Flex)`
  font-size: 3em;
  font-weight: 700;
`;

export const CalloutCardWrapper = styled.div`
  margin-bottom: 3em;
  @media only screen and (max-width: 768px) {
    .Polaris-CalloutCard__Image {
      display: none;
    }
  }
  @media only screen and (min-width: 768px) {
    .Polaris-CalloutCard__Image {
      width: 400px;
    }
  }
`;

export const MiniIcon = styled.div`
  .Polaris-Icon {
    margin: 0.25rem;
  }
`;

export const IdCheckOption = ({
  onClick,
  helperText,
  subtitle,
  title,
  icons,
  selected,
}) => {
  return (
    <div
      onClick={onClick}
      className={`ri-flex ri-rounded ri-border-2 ri-p-5 ri-relative ri-border-solid ri-cursor-pointer hover:ri-bg-gray-50 ${
        selected ? "ri-border-green-600 ri-shadow" : "ri-border-gray-300"
      }`}
    >
      <div>
        {icons}
        <h2 className="ri-text-lg ri-font-semibold ri-text-gray-700">
          {title}
        </h2>
        <p className="ri-text-gray-600 ri-text-base ri-max-w-md">
          {helperText}
        </p>
      </div>
      <span className="ri-absolute ri--top-3 ri--right-2 ri-bg-green-600 ri-text-white ri-rounded-full ri-p-2 ri-text-xs">
        {subtitle}
      </span>
    </div>
  );
};
